<mat-card appearance="outlined">
    <ng-container *ngIf="ready">
        <div class="row">
            <div class="col">
                <ng-container *ngFor="let msg of message; trackBy: trackByIndex">
                    <p>{{msg}}</p>
                </ng-container>
                <div class="text-center">
                    <br />
                    <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!ready">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>
</mat-card>